import type {
    NotificationPayload,
    NotificationResponse,
    SubscribeTopicNotificationPayload,
    UnSubscribeTopicNotificationPayload,
} from '@/types/apps/notification.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';

type NotificationListResponse = ApiResponse<
    PaginatedResult<NotificationResponse>
>;

export class NotificationService implements Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/Notifications',
        markAsRead: () => `/api/Notifications/mark-read`,
        subscribeTopic: () => `/api/Notifications/subscibe-topic`,
        unSubscribeTopic: () => `/api/Notifications/unsubscibe-topic`,
    };

    public index(params?: QueryParams): Promise<NotificationListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public markAsRead(
        payload: NotificationPayload
    ): Promise<ApiResponse<NotificationListResponse>> {
        return this.apiClient.postApi(this.endpoints.markAsRead(), payload);
    }

    public subscribeTopic(
        payload: SubscribeTopicNotificationPayload
    ): Promise<ApiResponse<NotificationListResponse>> {
        return this.apiClient.postApi(this.endpoints.subscribeTopic(), payload);
    }

    public unSubscribeTopic(
        payload: UnSubscribeTopicNotificationPayload
    ): Promise<ApiResponse<NotificationListResponse>> {
        return this.apiClient.postApi(
            this.endpoints.unSubscribeTopic(),
            payload
        );
    }
}
